import React from 'react';

import { Question } from './question';

import type { AskUserQuestionsToolCall } from './types';

interface Props {
  superseded: boolean;
  toolCalls: AskUserQuestionsToolCall[];
}

export function QuestionCards({ superseded, toolCalls }: Props) {
  return (
    <>
      {toolCalls.map(toolCall => (
        <Question key={toolCall.metadata.answerPath} superseded={superseded} toolCall={toolCall} />
      ))}
    </>
  );
}
